import { Controller } from "@hotwired/stimulus";
import { isHeic, heicTo } from "heic-to";

export default class AttachmentPreviewController extends Controller {
  static targets = ["source", "image", "video", "audio"];

  // this method to show the attachments before upload
  show() {
    // reset all preview targets once select a file
    this.hideAllPreviews();

    const file = this.sourceTarget.files[0];
    if (!file) return;

    const fileType = file.type;

    if (fileType.startsWith("image/")) {
      this.previewImage(file);
    } else if (fileType.startsWith("video/")) {
      this.previewVideo(file);
    } else if (fileType.startsWith("audio/")) {
      this.previewAudio(file);
    }
  }

  hideAllPreviews() {
    this.imageTarget.hidden = true;
    this.videoTarget.hidden = true;
    this.audioTarget.hidden = true;
  }

  async previewImage(file) {
    if (await isHeic(file)) {
      file = await heicTo({
        blob: file,
        toType: "image/jpeg",
      });
    }

    const reader = new FileReader();

    reader.onload = () => {
      this.imageTarget.src = reader.result;
      this.imageTarget.hidden = false;
    };
    reader.readAsDataURL(file);
  }

  previewVideo(file) {
    const url = URL.createObjectURL(file);
    this.videoTarget.src = url;
    this.videoTarget.hidden = false;
  }

  previewAudio(file) {
    const url = URL.createObjectURL(file);
    this.audioTarget.src = url;
    this.audioTarget.hidden = false;
  }

  handleModalSubmit() {
    this.hideAllPreviews();
  }
}
